import { SupplyAcquisitionMethods } from '../../../constants'
import t from './strings'
import { OrientationProps } from './types'

export const OrientationList: OrientationProps[] = [
  {
    title: t.mailItTitle(),
    buttonName: t.mailItButton(),
    eventName: 'DA_dxds_selection_page_dxds_selected',
    supplyAcquisitionMethod: SupplyAcquisitionMethods.DROPSHIPPING,
  },
  {
    title: t.pickUpTitle(),
    buttonName: t.pickUpButton(),
    eventName: 'DA_dxds_selection_page_scheduled_selected',
    supplyAcquisitionMethod: SupplyAcquisitionMethods.GO_INTO_OFFICE,
  },
]
